import { render, staticRenderFns } from "./RelationComponent.vue?vue&type=template&id=16b31324&"
import script from "./RelationComponent.vue?vue&type=script&lang=js&"
export * from "./RelationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b31324')) {
      api.createRecord('16b31324', component.options)
    } else {
      api.reload('16b31324', component.options)
    }
    module.hot.accept("./RelationComponent.vue?vue&type=template&id=16b31324&", function () {
      api.rerender('16b31324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/relation-component/RelationComponent.vue"
export default component.exports